/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MaterialIndexRouteImport } from './routes/material/index'
import { Route as EmployeeIndexRouteImport } from './routes/employee/index'
import { Route as ManagementImportRouteImport } from './routes/management/import'
import { Route as EmployeeReturnIndexRouteImport } from './routes/employee/return.index'
import { Route as EmployeeRegisterIndexRouteImport } from './routes/employee/register.index'
import { Route as EmployeeNewIndexRouteImport } from './routes/employee/new.index'
import { Route as EmployeeIssueIndexRouteImport } from './routes/employee/issue.index'
import { Route as EmployeeEmployeeIdIndexRouteImport } from './routes/employee/$employeeId.index'
import { Route as EmployeeEmployeeIdScheduleIndexRouteImport } from './routes/employee/$employeeId.schedule.index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialIndexRoute = MaterialIndexRouteImport.update({
  id: '/material/',
  path: '/material/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeIndexRoute = EmployeeIndexRouteImport.update({
  id: '/employee/',
  path: '/employee/',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagementImportRoute = ManagementImportRouteImport.update({
  id: '/management/import',
  path: '/management/import',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeReturnIndexRoute = EmployeeReturnIndexRouteImport.update({
  id: '/employee/return/',
  path: '/employee/return/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeRegisterIndexRoute = EmployeeRegisterIndexRouteImport.update({
  id: '/employee/register/',
  path: '/employee/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeNewIndexRoute = EmployeeNewIndexRouteImport.update({
  id: '/employee/new/',
  path: '/employee/new/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeIssueIndexRoute = EmployeeIssueIndexRouteImport.update({
  id: '/employee/issue/',
  path: '/employee/issue/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeEmployeeIdIndexRoute = EmployeeEmployeeIdIndexRouteImport.update({
  id: '/employee/$employeeId/',
  path: '/employee/$employeeId/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeEmployeeIdScheduleIndexRoute =
  EmployeeEmployeeIdScheduleIndexRouteImport.update({
    id: '/employee/$employeeId/schedule/',
    path: '/employee/$employeeId/schedule/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/management/import': typeof ManagementImportRoute
  '/employee/': typeof EmployeeIndexRoute
  '/material/': typeof MaterialIndexRoute
  '/employee/$employeeId/': typeof EmployeeEmployeeIdIndexRoute
  '/employee/issue/': typeof EmployeeIssueIndexRoute
  '/employee/new/': typeof EmployeeNewIndexRoute
  '/employee/register/': typeof EmployeeRegisterIndexRoute
  '/employee/return/': typeof EmployeeReturnIndexRoute
  '/employee/$employeeId/schedule/': typeof EmployeeEmployeeIdScheduleIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/management/import': typeof ManagementImportRoute
  '/employee': typeof EmployeeIndexRoute
  '/material': typeof MaterialIndexRoute
  '/employee/$employeeId': typeof EmployeeEmployeeIdIndexRoute
  '/employee/issue': typeof EmployeeIssueIndexRoute
  '/employee/new': typeof EmployeeNewIndexRoute
  '/employee/register': typeof EmployeeRegisterIndexRoute
  '/employee/return': typeof EmployeeReturnIndexRoute
  '/employee/$employeeId/schedule': typeof EmployeeEmployeeIdScheduleIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/management/import': typeof ManagementImportRoute
  '/employee/': typeof EmployeeIndexRoute
  '/material/': typeof MaterialIndexRoute
  '/employee/$employeeId/': typeof EmployeeEmployeeIdIndexRoute
  '/employee/issue/': typeof EmployeeIssueIndexRoute
  '/employee/new/': typeof EmployeeNewIndexRoute
  '/employee/register/': typeof EmployeeRegisterIndexRoute
  '/employee/return/': typeof EmployeeReturnIndexRoute
  '/employee/$employeeId/schedule/': typeof EmployeeEmployeeIdScheduleIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/management/import'
    | '/employee/'
    | '/material/'
    | '/employee/$employeeId/'
    | '/employee/issue/'
    | '/employee/new/'
    | '/employee/register/'
    | '/employee/return/'
    | '/employee/$employeeId/schedule/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/management/import'
    | '/employee'
    | '/material'
    | '/employee/$employeeId'
    | '/employee/issue'
    | '/employee/new'
    | '/employee/register'
    | '/employee/return'
    | '/employee/$employeeId/schedule'
  id:
    | '__root__'
    | '/'
    | '/management/import'
    | '/employee/'
    | '/material/'
    | '/employee/$employeeId/'
    | '/employee/issue/'
    | '/employee/new/'
    | '/employee/register/'
    | '/employee/return/'
    | '/employee/$employeeId/schedule/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ManagementImportRoute: typeof ManagementImportRoute
  EmployeeIndexRoute: typeof EmployeeIndexRoute
  MaterialIndexRoute: typeof MaterialIndexRoute
  EmployeeEmployeeIdIndexRoute: typeof EmployeeEmployeeIdIndexRoute
  EmployeeIssueIndexRoute: typeof EmployeeIssueIndexRoute
  EmployeeNewIndexRoute: typeof EmployeeNewIndexRoute
  EmployeeRegisterIndexRoute: typeof EmployeeRegisterIndexRoute
  EmployeeReturnIndexRoute: typeof EmployeeReturnIndexRoute
  EmployeeEmployeeIdScheduleIndexRoute: typeof EmployeeEmployeeIdScheduleIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/material/': {
      id: '/material/'
      path: '/material'
      fullPath: '/material/'
      preLoaderRoute: typeof MaterialIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/': {
      id: '/employee/'
      path: '/employee'
      fullPath: '/employee/'
      preLoaderRoute: typeof EmployeeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/management/import': {
      id: '/management/import'
      path: '/management/import'
      fullPath: '/management/import'
      preLoaderRoute: typeof ManagementImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/return/': {
      id: '/employee/return/'
      path: '/employee/return'
      fullPath: '/employee/return/'
      preLoaderRoute: typeof EmployeeReturnIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/register/': {
      id: '/employee/register/'
      path: '/employee/register'
      fullPath: '/employee/register/'
      preLoaderRoute: typeof EmployeeRegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/new/': {
      id: '/employee/new/'
      path: '/employee/new'
      fullPath: '/employee/new/'
      preLoaderRoute: typeof EmployeeNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/issue/': {
      id: '/employee/issue/'
      path: '/employee/issue'
      fullPath: '/employee/issue/'
      preLoaderRoute: typeof EmployeeIssueIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/$employeeId/': {
      id: '/employee/$employeeId/'
      path: '/employee/$employeeId'
      fullPath: '/employee/$employeeId/'
      preLoaderRoute: typeof EmployeeEmployeeIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/$employeeId/schedule/': {
      id: '/employee/$employeeId/schedule/'
      path: '/employee/$employeeId/schedule'
      fullPath: '/employee/$employeeId/schedule/'
      preLoaderRoute: typeof EmployeeEmployeeIdScheduleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ManagementImportRoute: ManagementImportRoute,
  EmployeeIndexRoute: EmployeeIndexRoute,
  MaterialIndexRoute: MaterialIndexRoute,
  EmployeeEmployeeIdIndexRoute: EmployeeEmployeeIdIndexRoute,
  EmployeeIssueIndexRoute: EmployeeIssueIndexRoute,
  EmployeeNewIndexRoute: EmployeeNewIndexRoute,
  EmployeeRegisterIndexRoute: EmployeeRegisterIndexRoute,
  EmployeeReturnIndexRoute: EmployeeReturnIndexRoute,
  EmployeeEmployeeIdScheduleIndexRoute: EmployeeEmployeeIdScheduleIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
